import { useTranslation } from 'react-i18next';
import type { OpticalJobPrescription } from '@optiflow/types';

type Origin = Pick<OpticalJobPrescription, 'source' | 'clinicalPrescriptionNumber'> | null;

/**
 * Where a job's prescription came from, never a value from it.
 *
 * A clinical prescription by its number, one typed from an outside prescription as external, and one a LEGACY job kept from before optical jobs as such — never passed off as external.
 */
export function PrescriptionOrigin({ prescription }: { prescription: Origin }) {
  const { t } = useTranslation();
  if (!prescription) return <>{t('opticalOrders.tracking.noPrescription')}</>;
  if (prescription.source === 'CLINICAL_PRESCRIPTION') {
    return (
      <span className="font-mono" dir="ltr">
        {prescription.clinicalPrescriptionNumber ?? '—'}
      </span>
    );
  }
  if (prescription.source === 'EXTERNAL_PRESCRIPTION') {
    return <>{t('opticalOrders.tracking.external')}</>;
  }
  return <>{t('opticalOrders.job.sourceLegacy')}</>;
}
